import { LEGAL_DOCUMENTS_BASE_URL } from "@/common/constants";

export const LEGAL_DOCUMENT_TYPES = [
    "license",
    "terms",
    "privacy",
    "data-processing"
];

export const LEGAL_DOCUMENT_SLUGS = {
    license: "licencia",
    terms: "terminos",
    privacy: "privacidad",
    "data-processing": "encargo-datos"
};

export const LEGAL_DOCUMENT_LABELS = {
    license: "Licencia de uso",
    terms: "Términos y condiciones",
    privacy: "Política de tratamiento de datos",
    "data-processing": "Anexo de transmisión de datos"
};

export const LEGAL_CONSENT_GROUPS = [
    {
        key: "contract",
        documentTypes: ["license", "terms", "data-processing"],
        label: "Acepto la Licencia de uso, los Términos y condiciones y el Anexo de transmisión de datos"
    },
    {
        key: "privacy",
        documentTypes: ["privacy"],
        label: "Autorizo el tratamiento de mis datos según la Política de tratamiento de datos"
    }
];

export const IMAGE_RIGHTS_NOTICE =
    "Al subir una imagen declaras que es tuya o que tienes permiso para usarla.";

export const toAcceptancePayload = (documents = []) =>
    documents.map(({ documentType, version }) => ({ documentType, version }));

export const buildLegalDocumentUrl = (documentType) =>
    `${LEGAL_DOCUMENTS_BASE_URL}/${LEGAL_DOCUMENT_SLUGS[documentType]}`;
